// ============================================================================
// PATCH [2026-04-04] — Swipe-path variant desync fix
// ----------------------------------------------------------------------------
// Reported bug: customer on Facebook in-app webview reported that selecting
// a colour combination on The Wren produced a different combination in the
// cart. Video confirmed the slider swatches and main image were showing the
// selected colour, but the cart contained a different variant. Customer was
// a developer who flagged it as looking like an off-by-1 on the colour keys.
//
// Root cause: the CB override inside theme.js changeVariant() (search for
// "cb custom") reads .custom-options-container input[type="radio"]:checked
// synchronously to rebuild the correct variant key, because the Alpine
// @change handler on the native radios is server-rendered with a hardcoded
// value.variant.id that is only correct for single-option products. That
// synchronous read requires the custom radios to already reflect the new
// selection at the moment changeVariant runs.
//
// On direct label clicks this happened "for free" — the browser's native
// for=/id= behaviour checks the custom radio before Slick's focusOnSelect
// fires. But on swipes, arrow clicks, or any programmatic slickGoTo, the
// custom radio was never marked checked before triggerNativeOption() was
// called. The CB override then read the PREVIOUS selection and committed
// the wrong variant ID to the cart. Slider UI looked correct, cart was
// wrong. Swipe-heavy (mobile / in-app webview) users were disproportionately
// affected.
//
// The non-swatch (plain radio) afterChange handlers already had the
// equivalent $customInput.prop('checked', true) line. The bug was that all
// three swatch-path handlers (top / middle / bottom) were missing it.
//
// Fix: explicitly uncheck same-name siblings in .custom-options-container
// and check the target custom input BEFORE calling triggerNativeOption.
// Explicit uncheck rather than relying on radio-group exclusivity because
// form-owner semantics between custom radios and native radios are not
// guaranteed across all product templates.
//
// Verified on desktop Chrome against The Wren via console reproduction:
// before fix, slickGoTo(2) on the Body swatch carousel left both the
// custom container and native picker reporting the original Body colour
// while the slider UI showed the new one; after the pre-sync, both
// containers correctly reported the new colour and the section rendered
// the right variant form.
//
// See also: theme.js changeVariant() — a passive sanity-check logger has
// been added there to detect regressions of this class in production.
// ============================================================================

(function($) {
  
  function cbPenSlider() {
    if ($('.custom-slider-section').length) {
      console.log('========= CUSTOM SLIDER ======');

      const nativePickerRoot = '.product__block__variants .form__selectors';

      function escapeSelectorValue(value) {
        if (window.CSS && typeof window.CSS.escape === 'function') {
          return window.CSS.escape(value);
        }
        return String(value).replace(/"/g, '\\"');
      }

      function getOptionNameFromInput($input) {
        const rawName = $input.attr('name') || '';
        const match = rawName.match(/^options\[(.*)\]$/);
        return match ? match[1] : '';
      }

      function getNativeInput(optionName, optionValue) {
        const safeOptionName = escapeSelectorValue(optionName);
        const safeOptionValue = escapeSelectorValue(optionValue);

        return $(nativePickerRoot)
          .find(`input[name="options[${safeOptionName}]"][value="${safeOptionValue}"]`)
          .first();
      }

      function triggerNativeOption(optionName, optionValue) {
        const $nativeInput = getNativeInput(optionName, optionValue);

        if (!$nativeInput.length) {
          console.warn('Native option not found:', optionName, optionValue);
          return;
        }

        const nativeInput = $nativeInput.get(0);
        if (!nativeInput) return;

        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        nativeInput.checked = true;
        nativeInput.dispatchEvent(new Event('input', { bubbles: true }));
        nativeInput.dispatchEvent(new Event('change', { bubbles: true }));

        requestAnimationFrame(function() {
          window.scrollTo(scrollX, scrollY);
        });
      }

      function syncCustomOptionState($customContainer) {
        $customContainer.find('input[type="radio"]').each(function() {
          const $customInput = $(this);
          const optionName = getOptionNameFromInput($customInput);
          const optionValue = $customInput.val();

          if (!optionName || !optionValue) return;

          const $nativeInput = getNativeInput(optionName, optionValue);
          if (!$nativeInput.length) return;

          const isChecked = $nativeInput.prop('checked');
          const isDisabled = $nativeInput.prop('disabled');

          $customInput.prop('checked', isChecked);
          $customInput.prop('disabled', isDisabled);

          if (isChecked) {
            $customInput.attr('checked', 'checked');
          } else {
            $customInput.removeAttr('checked');
          }

          if (isDisabled) {
            $customInput.attr('disabled', 'disabled');
          } else {
            $customInput.removeAttr('disabled');
          }

          const nativeClass = $nativeInput.attr('class') || '';
          const isSoldOut = nativeClass.indexOf('sold-out') !== -1;
          const isUnavailable = nativeClass.indexOf('unavailable') !== -1;

          // $customInput.toggleClass('sold-out', isSoldOut);
          $customInput.toggleClass('unavailable', isUnavailable);

          const $customWrapper = $customInput.closest('.radio__button, .swatch__button');
          // $customWrapper.toggleClass('sold-out', isSoldOut);
          $customWrapper.toggleClass('unavailable', isUnavailable);

          if (isChecked) {
            $customContainer
              .parents('fieldset')
              .find('[data-option-value]')
              .html(optionValue);
          }
        });
      }

      function syncAllCustomOptions() {
        if (top_slider_option_alias !== false) {
          syncCustomOptionState($('#custom-' + top_slider_option_alias + '-thumbnails'));
        }
        if (middle_slider_option_alias !== false) {
          syncCustomOptionState($('#custom-' + middle_slider_option_alias + '-thumbnails'));
        }
        if (bottom_slider_option_alias !== false) {
          syncCustomOptionState($('#custom-' + bottom_slider_option_alias + '-thumbnails'));
        }
      }

      let top_slider_option_alias = false;
      let middle_slider_option_alias = false;
      let bottom_slider_option_alias = false;

      let top_slider_json_el = $('#top_option_slider_json');
      let middle_slider_json_el = $('#middle_option_slider_json');
      let bottom_slider_json_el = $('#bottom_option_slider_json');
      if (top_slider_json_el.length > 0) {
        let top_slider_json = JSON.parse($(top_slider_json_el).text());
        for (let idx = 0; idx < top_slider_json.length; idx++) {
          top_slider_option_alias = top_slider_json[idx]['option_name_handleize'];
        }
      }
      if (middle_slider_json_el.length > 0) {
        let middle_slider_json = JSON.parse($(middle_slider_json_el).text());
        for (let idx = 0; idx < middle_slider_json.length; idx++) {
          middle_slider_option_alias = middle_slider_json[idx]['option_name_handleize'];
        }
      }
      if (bottom_slider_json_el.length > 0) {
        let bottom_slider_json = JSON.parse($(bottom_slider_json_el).text());
        for (let idx = 0; idx < bottom_slider_json.length; idx++) {
          bottom_slider_option_alias = bottom_slider_json[idx]['option_name_handleize'];
        }
      }

      const arrowPrev = "<button class='flickity-button flickity-prev-next-button previous lid-previous' type='button' aria-label='Previous'><svg class='flickity-button-icon' viewBox='0 0 100 100'><title>Previous</title><path d='M 10, 50 L 60, 100 L 67.5, 92.5 L 25, 50 L 67.5, 7.5 L 60, 0 Z' class='arrow' ></path></svg></button>",
            arrowNext = "<button class='flickity-button flickity-prev-next-button next lid-next' type='button' aria-label='Next'><svg class='flickity-button-icon' viewBox='0 0 100 100'><title>Next</title><path d='M 10, 50 L 60, 100 L 67.5, 92.5 L 25, 50 L 67.5, 7.5 L 60, 0 Z' class='arrow' transform='translate(100, 100) rotate(180)'></path></svg></button>";

      // TOP Slider
      if (top_slider_option_alias !== false) {
        const topSliderTarget = $('#main-custom-' + top_slider_option_alias).find('.main-carousel');
        const topSwatchesTarget = $('#custom-' + top_slider_option_alias + '-thumbnails');

        const swatchesCount = topSwatchesTarget.find('radio-swatch').length;
        let swatchesToShow = swatchesCount <= 5 ? 3 : 5;
        
        if ($(topSwatchesTarget).hasClass('cb-swatch-opt')) {
          
          let swatchesTopOptions = {
            slidesToShow: swatchesToShow,
            infinite: true,
            dots: false,
            asNavFor: topSliderTarget,
            centerMode: true,
            focusOnSelect: true,
            arrows:false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: swatchesToShow
                }
              }
            ]
          };

          topSliderTarget.on('init', function(event, slick, currentSlide) {
            let currentSlideTop = $(slick.$slides.get(currentSlide));
            currentSlideTop.parents('.custom-slider-section').find('.loader').hide();
            currentSlideTop.parents('.custom-slider-section').find('.preloader').fadeOut();

            let $checkedInput = topSwatchesTarget.find('input:checked').first();

            if ($checkedInput.length) {
              let selectedIndex = $checkedInput.closest('.slick-slide').data('slick-index');

              if (selectedIndex === undefined || selectedIndex < 0) {
                selectedIndex = $checkedInput.closest('.swatch__button').index();
              }

              if (selectedIndex >= 0) {
                setTimeout(function() {
                  topSliderTarget.slick('slickGoTo', selectedIndex, true);
                  topSwatchesTarget.slick('slickGoTo', selectedIndex, true);
                  topSliderTarget.slick('setPosition');
                  topSwatchesTarget.slick('setPosition');
                }, 0);
              }
            }
          });

          topSwatchesTarget.slick(swatchesTopOptions);

          let times = 2;

          topSwatchesTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideTop = $(slick.$slides.get(currentSlide));

            if (!currentSlideTop.hasClass('slick-cloned')) {
              let $customInput = currentSlideTop.find('input').first();
              let optionName = getOptionNameFromInput($customInput);
              let optionValue = $customInput.val();

              if (optionName && optionValue) {
                const nameAttr = 'options[' + optionName + ']';
                $('.custom-options-container input[type="radio"]').filter(function() {
                  return this.name === nameAttr;
                }).prop('checked', false);
                $customInput.prop('checked', true);

                triggerNativeOption(optionName, optionValue);
                currentSlideTop.parents('fieldset').find('[data-option-value]').html(optionValue);
              }
            }

            if (times === 0) {
              topSliderTarget.slick('slickPause');
              topSwatchesTarget.slick('slickPause');
            }
            --times;
          });
          topSliderTarget.on('init', function(event, slick, currentSlide, nextSlide){
            let currentSlideTop = $(slick.$slides.get(currentSlide)); 
            currentSlideTop.parents('.custom-slider-section').find('.loader').hide();
            currentSlideTop.parents('.custom-slider-section').find('.preloader').fadeOut();
          });

          $sliderTop = topSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            asNavFor:topSwatchesTarget,
            autoplay: false,
            autoplaySpeed: 4000
          });
        } else {
          $sliderTop = topSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            autoplay: false,
            autoplaySpeed: 4000
          });

          let times = 2;

          topSliderTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideTop = $(slick.$slides.get(currentSlide));  
            currentSlideTop.parents('.product-page').find('#custom-' + top_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
              if (i == currentSlide) {
                let $customInput = $(this).find('input').first();
                let optionName = getOptionNameFromInput($customInput);
                let optionValue = $customInput.val();

                $customInput.prop('checked', true);

                if (optionName && optionValue) {
                  triggerNativeOption(optionName, optionValue);
                }
              }
              
            });

            if (times === 0) {
              topSliderTarget.slick('slickPause');
            }
            --times;
          });
          $('#custom-' + top_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
            $(this).find('label').on('click', function() {
              topSliderTarget.slick('slickGoTo', i);
            });
          });
          
          topSliderTarget.on('init', function(event, slick, currentSlide, nextSlide){
            let currentSlideTop = $(slick.$slides.get(currentSlide));
            currentSlideTop.parents('.custom-slider-section').find('.loader').hide();
            currentSlideTop.parents('.custom-slider-section').find('.preloader').fadeOut();
          });
        }

      }

      // MIDDLE Slider
      if (middle_slider_option_alias !== false) {
        const middleSliderTarget = $('#main-custom-' + middle_slider_option_alias).find('.main-carousel');
        const middleSwatchesTarget = $('#custom-' + middle_slider_option_alias + '-thumbnails');
      
        const swatchesCount = middleSwatchesTarget.find('radio-swatch').length;
        const swatchesToShow = swatchesCount <= 5 ? 3 : 5;
      
        if ($(middleSwatchesTarget).hasClass('cb-swatch-opt')) {
          let swatchesMiddleOptions = {
            slidesToShow: swatchesToShow,
            infinite: true,
            dots: false,
            asNavFor: middleSliderTarget,
            centerMode: true,
            focusOnSelect: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: swatchesToShow
                }
              }
            ]
          };

          middleSliderTarget.on('init', function(event, slick, currentSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));
            currentSlideMiddle.parents('.custom-slider-section').find('.loader').hide();
            currentSlideMiddle.parents('.custom-slider-section').find('.preloader').fadeOut();

            let $checkedInput = middleSwatchesTarget.find('input:checked').first();

            if ($checkedInput.length) {
              let selectedIndex = $checkedInput.closest('.slick-slide').data('slick-index');

              if (selectedIndex === undefined || selectedIndex < 0) {
                selectedIndex = $checkedInput.closest('.swatch__button').index();
              }

              if (selectedIndex >= 0) {
                setTimeout(function() {
                  middleSliderTarget.slick('slickGoTo', selectedIndex, true);
                  middleSwatchesTarget.slick('slickGoTo', selectedIndex, true);
                  middleSliderTarget.slick('setPosition');
                  middleSwatchesTarget.slick('setPosition');
                }, 0);
              }
            }
          });

          middleSwatchesTarget.slick(swatchesMiddleOptions);

          let times = 2;

          middleSwatchesTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));

            if (!currentSlideMiddle.hasClass('slick-cloned')) {
              let $customInput = currentSlideMiddle.find('input').first();
              let optionName = getOptionNameFromInput($customInput);
              let optionValue = $customInput.val();

              if (optionName && optionValue) {
                const nameAttr = 'options[' + optionName + ']';
                $('.custom-options-container input[type="radio"]').filter(function() {
                  return this.name === nameAttr;
                }).prop('checked', false);
                $customInput.prop('checked', true);

                triggerNativeOption(optionName, optionValue);
                currentSlideMiddle.parents('fieldset').find('[data-option-value]').html(optionValue);
              }
            }

            if (times === 0) {
              middleSliderTarget.slick('slickPause');
              middleSwatchesTarget.slick('slickPause');
            }
            --times;
          });

          middleSliderTarget.on('init', function(event, slick, currentSlide, nextSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));
            currentSlideMiddle.parents('.custom-slider-section').find('.loader').hide();
            currentSlideMiddle.parents('.custom-slider-section').find('.preloader').fadeOut();
          });

          $sliderMiddle = middleSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            asNavFor: middleSwatchesTarget,
            autoplay: false,
            autoplaySpeed: 2000
          });
        } else {
          $sliderMiddle = middleSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            autoplay: false,
            autoplaySpeed: 2000
          });
      
          let times = 2;
      
          middleSliderTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));

            currentSlideMiddle.parents('.product-page').find('#custom-' + middle_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
              if (i == currentSlide) {
                let $customInput = $(this).find('input').first();
                let optionName = getOptionNameFromInput($customInput);
                let optionValue = $customInput.val();

                $customInput.prop('checked', true);

                if (optionName && optionValue) {
                  triggerNativeOption(optionName, optionValue);
                }
              }

            });
      
            if (times === 0) {
              middleSliderTarget.slick('slickPause');
            }
            --times;
          });
      
          $('#custom-' + middle_slider_option_alias + '-thumbnails .radio__button').each(function(i) {
            $(this).find('label').on('click', function() {
              middleSliderTarget.slick('slickGoTo', i);
            });
          });
      
          middleSliderTarget.on('init', function(event, slick, currentSlide, nextSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));
            currentSlideMiddle.parents('.custom-slider-section').find('.loader').hide();
            currentSlideMiddle.parents('.custom-slider-section').find('.preloader').fadeOut();
          });
        }
      }

      // BOTTOM Slider
      if (bottom_slider_option_alias !== false) {
        const bottomSliderTarget = $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel');
        const bottomSwatchesTarget = $('#custom-' + bottom_slider_option_alias + '-thumbnails');

        const swatchesCount = bottomSwatchesTarget.find('radio-swatch').length;
        const swatchesToShow = swatchesCount <= 5 ? 3 : 5;

        if ($(bottomSwatchesTarget).hasClass('cb-swatch-opt')) {
          let swatchesBottomOptions = {
            slidesToShow: swatchesToShow,
            infinite: true,
            dots: false,
            asNavFor: bottomSliderTarget,
            centerMode: true,
            focusOnSelect: true,
            arrows:false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: swatchesToShow
                }
              }
            ]
          };

          bottomSliderTarget.on('init', function(event, slick, currentSlide) {
            let currentSlideBottom = $(slick.$slides.get(currentSlide));
            currentSlideBottom.parents('.custom-slider-section').find('.loader').hide();
            currentSlideBottom.parents('.custom-slider-section').find('.preloader').fadeOut();

            let $checkedInput = bottomSwatchesTarget.find('input:checked').first();

            if ($checkedInput.length) {
              let selectedIndex = $checkedInput.closest('.slick-slide').data('slick-index');

              if (selectedIndex === undefined || selectedIndex < 0) {
                selectedIndex = $checkedInput.closest('.swatch__button').index();
              }

              if (selectedIndex >= 0) {
                setTimeout(function() {
                  bottomSliderTarget.slick('slickGoTo', selectedIndex, true);
                  bottomSwatchesTarget.slick('slickGoTo', selectedIndex, true);
                  bottomSliderTarget.slick('setPosition');
                  bottomSwatchesTarget.slick('setPosition');
                }, 0);
              }
            }
          });

          bottomSwatchesTarget.slick(swatchesBottomOptions);

          let times = 2;

          bottomSwatchesTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideBottom = $(slick.$slides.get(currentSlide));

            if (!currentSlideBottom.hasClass('slick-cloned')) {
              let $customInput = currentSlideBottom.find('input').first();
              let optionName = getOptionNameFromInput($customInput);
              let optionValue = $customInput.val();

              if (optionName && optionValue) {
                const nameAttr = 'options[' + optionName + ']';
                $('.custom-options-container input[type="radio"]').filter(function() {
                  return this.name === nameAttr;
                }).prop('checked', false);
                $customInput.prop('checked', true);

                triggerNativeOption(optionName, optionValue);
                currentSlideBottom.parents('fieldset').find('[data-option-value]').html(optionValue);
              }
            }

            if (times === 0) {
              bottomSliderTarget.slick('slickPause');
              bottomSwatchesTarget.slick('slickPause');
            }
            --times;
          });
          bottomSliderTarget.on('init', function(event, slick, currentSlide, nextSlide){
            let currentSlideBottom = $(slick.$slides.get(currentSlide)); 
            currentSlideBottom.parents('.custom-slider-section').find('.loader').hide();
            currentSlideBottom.parents('.custom-slider-section').find('.preloader').fadeOut();
          });

          $sliderBottom = bottomSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            asNavFor:bottomSwatchesTarget,
            autoplay: false,
            autoplaySpeed: 3000
          });
        } else {
          $sliderBottom = bottomSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            autoplay: false,
            autoplaySpeed: 3000
          });

          let times = 2;

          bottomSliderTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideBottom = $(slick.$slides.get(currentSlide));

            currentSlideBottom.parents('.product-page').find('#custom-' + bottom_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
              if (i == currentSlide) {
                let $customInput = $(this).find('input').first();
                let optionName = getOptionNameFromInput($customInput);
                let optionValue = $customInput.val();

                $customInput.prop('checked', true);

                if (optionName && optionValue) {
                  triggerNativeOption(optionName, optionValue);
                }
              }

            });

            if (times === 0) {
              bottomSliderTarget.slick('slickPause');
            }
            --times;
          });

          $('#custom-' + bottom_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
            $(this).find('label').on('click', function() {
              bottomSliderTarget.slick('slickGoTo', i);
            });
          });

          bottomSliderTarget.on('init', function(event, slick, currentSlide, nextSlide){
            let currentSlideBottom = $(slick.$slides.get(currentSlide));
            currentSlideBottom.parents('.custom-slider-section').find('.loader').hide();
            currentSlideBottom.parents('.custom-slider-section').find('.preloader').fadeOut();
          });
        }

      }

      $('.custom-slider-container .flickity-prev-next-button').on('click', function() {
        if (top_slider_option_alias !== false) {
          $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (middle_slider_option_alias !== false) {
          $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (bottom_slider_option_alias !== false) {
          $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
      });

      $('label.cb-slider-option-label').on('click', function() {
        if (top_slider_option_alias !== false) {
          $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (middle_slider_option_alias !== false) {
          $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (bottom_slider_option_alias !== false) {
          $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
      });

      // $('.cb-slider-option-label').on('click', function() {
      // // $('.radio__inputs.cb-swatch-opt').on('click', function() {
      //   if (top_slider_option_alias !== false) {
      //     $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
      //   }
      //   if (middle_slider_option_alias !== false) {
      //     $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
      //   }
      //   if (bottom_slider_option_alias !== false) {
      //     $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
      //   }
      // });

      if (top_slider_option_alias !== false) {
        $('#main-custom-' + top_slider_option_alias).find('.main-carousel').on('swipe', function(event, slick, direction) {
          $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
          if (middle_slider_option_alias !== false) {
            $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          if (bottom_slider_option_alias !== false) {
            $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
        });
      }

      if (middle_slider_option_alias !== false) {
        $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').on('swipe', function(event, slick, direction) {
          if (top_slider_option_alias !== false) {
            $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
          if (bottom_slider_option_alias !== false) {
            $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
        });
      }

      if (bottom_slider_option_alias !== false) {
        $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').on('swipe', function(event, slick, direction) {
          if (top_slider_option_alias !== false) {
            $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          if (middle_slider_option_alias !== false) {
            $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
        });
      }

      syncAllCustomOptions();

      $(document).on('change', nativePickerRoot + ' input[type="radio"]', function() {
        setTimeout(function() {
          syncAllCustomOptions();
        }, 0);
      });

      const nativePickerNode = document.querySelector('.product__block__variants .form__selectors');
      if (nativePickerNode && !nativePickerNode._cbObserverAttached) {
        const observer = new MutationObserver(function() {
          syncAllCustomOptions();
        });

        observer.observe(nativePickerNode, {
          childList: true,
          subtree: true,
          attributes: true
        });

        nativePickerNode._cbObserverAttached = true;
      }

      if (window.matchMedia("(min-width: 768px)").matches && $('.position--gallery').length) {
        $('.custom-options-container').insertBefore('.product__main__content .product__block__buttons');
      } 
      if (window.matchMedia("(max-width: 767px)").matches) {
        // $(".product__block__title, div[id^='shopify-block-judge_me_reviews_preview_badge_']").wrapAll("<div class='title-review'>");
        // $('.title-review').prependTo('.product-page');
        // $('.cb-gallery-js').insertAfter('.product__main__content .product__block__buttons');
      }
  
    } //endif
  } //end slider function

  
  $(document).ready(function() {
    cbPenSlider();
    if ($('.custom-slider-section').length) {
      // let container = document.querySelector('.custom-slider-section');
      // const productRoot = container.closest('[x-data]');
      // const productData = Alpine.$data(productRoot);

      // container.addEventListener('click', (e) => {
      //   const swatch = e.target.closest('[data-swatch]');
      //   if (!swatch) return;
      //   if (swatch.closest('.slick-cloned')) return;

      //   productData.$sectionApi.navigate(swatch.dataset.variantUrl, 'replace');
      // });
    }
    
  });
})(jQuery);